import React, { Component } from "react";
import CaffenioDriveAPI from "../../services/SoporteTools";
import ConfigurationVPAPI from "../../services/ConfigurationVP";
import NoItems from "../util/noitems/NoItems";
import ServerPagination from "../util/pagination/ServerPagination";
import Loading from "../util/loading/Loading";
import ComboDatosAPI from "../../services/ComboDatos";
import { ConfiguracionVP } from "../ConfiguracionVP";
import { toast } from "react-toastify";
import Select from "react-select";
import Field from "../util/field/Field";
import Modal from "../util/modal/Modal";
import AcceptModal from "../util/acceptModal/AcceptModal";
import "./caffenioStyle.css";
import lodash from "lodash";

import BtnModoGuiado from "../util/BtnModoGuiado/BtnModoGuiado";
import ErrorMessages from "../../util/validation-error-messages";

class CaffenioDrive extends Component {
  state = {
    isLoading: false,
    Caffenios: [],
    showModal: false,
    caffenio: null,
    configVP: null,
    showConfigVP: false,
    showConfirm: false,
    tipoDeSolicitudes: [],
    segmentos: [],
    filtros: {},
    estatus: [
      { label: "Activo", value: "activo" },
      { label: "Inactivo", value: "inactivo" },
      { label: "Registro incompleto", value: "registro_incompleto" },
      { label: "Pendiente usuario Auth", value: "pendiente_auth" },
    ],
    Paginator: {
      Page: 0,
      PageSize: 0,
      TotalRecords: 0,
      TotalPages: 0,
    },
  };

  cancel = () => {
    this.setState({ showModal: false, showConfigVP: false, configVP: null });
  };

  componentDidMount() {
    let state = { ...this.state };

    ConfigurationVPAPI.GetTipoSolicitudes()
      .then((response) => {
        let data = response.data;
        let finalData = [];
        data.map((item) => {
          finalData.push(item);
        });
        state.tipoDeSolicitudes = finalData;
        return ComboDatosAPI.getSegment();
      })
      .then((response) => {
        let data = response.data.filter((d) => {
          if (d.Active) {
            d.label = d.Name;
            d.value = d.SegmentId;
            return d;
          }
        });
        state.segmentos = lodash.sortBy(
          data,
          [(ts) => ts.Name.toLowerCase()],
          ["asc"],
        );
      })
      .catch((err) => {
        if (err.response) toast.error(err.response.data.Message);
        else toast.error(ErrorMessages.SinConexion);
      })
      .finally(() => this.setState(state, () => this.getData()));
  }

  /**
   * Función que obtiene información de los PDV
   * @param {*} page
   */
  getData = (page) => {
    page = page || this.state.Paginator.Page;
    let _state = { ...this.state };
    _state.isLoading = false;
    _state.showConfirm = false;
    let filtros = this.getFilterValues();
    CaffenioDriveAPI.getAllPdv(page, filtros)
      .then((response) => {
        _state.Caffenios = response.data ? response.data.Results : [];
        _state.Paginator = {
          Page: response.data.Page,
          PageSize: response.data.PageSize,
          TotalRecords: response.data.TotalRecords,
          TotalPages: response.data.TotalPages,
        };

        _state.Caffenios.map((producto) => {
          producto.statusCheck = false;
          return producto;
        });
      })
      .catch((err) => {
        if (err.response) toast.error(err.response.data.Message);
        else toast.error(ErrorMessages.SinConexion);
      })
      .finally(() => this.setState(_state));
  };

  getFilterValues = () => {
    let filters = {};
    Object.keys(this.state.filtros).forEach((attr_name) => {
      if (
        this.state.filtros[`${attr_name}`] &&
        this.state.filtros[`${attr_name}`].value
      )
        filters[`${attr_name}`] = this.state.filtros[`${attr_name}`].value;
    });
    if (this.state.filtros.searchText)
      filters["searchText"] = this.state.filtros.searchText;
    return filters;
  };

  /**
   * Guarda en el state la busqueda
   * @param {*} text
   */
  handleSearchInput = (text) => {
    let state = { ...this.state };
    state.filtros.searchText = text;
    this.setState(state);
  };

  handleFilterChange = (filtername, value) => {
    let state = { ...this.state };
    if (filtername == "ddlestatus") {
      state.ddlestatus = value;
      state.filtros["estatus"] = null;
      state.filtros["popAuth"] = null;
      state.filtros["pending"] = null;
      if (value)
        switch (value.value) {
          case "activo":
            state.filtros["estatus"] = { value: "true" };
            break;
          case "inactivo":
            state.filtros["estatus"] = { value: "false" };
            break;
          case "pendiente_auth":
            state.filtros["popAuth"] = { value: "false" };
            break;
          case "registro_incompleto":
            state.filtros["pending"] = { value: "true" };
            break;
        }
    } else {
      state.filtros[`${filtername}`] = value;
    }

    this.setState(state);
  };

  eliminarObjDuplicados = (arr, prop) => {
    var nuevoArray = [];
    var lookup = {};

    for (var i in arr) {
      lookup[arr[i][prop]] = arr[i];
    }

    for (i in lookup) {
      nuevoArray.push(lookup[i]);
    }

    return nuevoArray;
  };

  changeStatus = () => {
    this.setState({ isLoading: true }, () => {
      if (!this.state.caffenio)
        toast.warn("Intente nuevamente no se encontró punto de venta.");
      CaffenioDriveAPI.patchStatus(this.state.caffenio.id)
        .then((response) => {
          toast.success("Punto de venta actualizado");
          this.getData();
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          if (err.response) toast.error(err.response.data.Message);
          else toast.error(ErrorMessages.SinConexion);
        });
    });
  };

  syncPdv = () => {
    if (!this.state.caffenio)
      toast.warn("Intente nuevamente no se encontró punto de venta.");
    CaffenioDriveAPI.syncAuth(this.state.caffenio.id)
      .then((response) => {
        toast.success("Punto de venta actualizado");
        this.getData();
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        if (err.response) toast.error(err.response.data.Message);
        else toast.error(ErrorMessages.SinConexion);
      });
  };

  edit = (caffenio) => {
    this.props.history.push({
      pathname: "/puntos-de-venta-detail",
      state: {
        caffenio: caffenio,
        segmentos: this.state.segmentos,
        isEditing: true,
      },
    });
  };

  macs = (caffenio) => {
    this.props.history.push({
      pathname: "/puntos-de-venta-macs",
      state: {
        caffenio: caffenio,
        caffenioId: caffenio.id,
      },
    });
  };

  horarios = (caffenio) => {
    this.props.history.push({
      pathname: "/puntos-de-venta-horarios",
      state: {
        caffenio: caffenio,
        caffenioId: caffenio.id,
      },
    });
  };

  

  render() {
    return (
      <div>
        <h1 className="title is-2">Puntos de Venta</h1>

        <div className="card">
          <div className="card-content">
            <div className="columns is-multiline">
              <div className="column is-6">
                <label className="label">Buscar</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    placeholder={`Busqueda por nombre, correo, cr, centro o destinatario de mercancía`}
                    value={this.state.filtros.searchText}
                    autoFocus={true}
                    onChange={(e) =>
                      this.handleSearchInput(e.currentTarget.value)
                    }
                  />
                </div>
              </div>
              <div className="column is-3">
                <label className="label">Estatus</label>
                <div className="control">
                  <Select
                    placeholder={"Seleccionar..."}
                    name={"ddlStatus"}
                    value={this.state.ddlestatus}
                    onChange={(value) =>
                      this.handleFilterChange("ddlestatus", value)
                    }
                    noOptionsMessage={() => "No hay opciones"}
                    options={this.state.estatus}
                    isClearable
                  />
                </div>
              </div>
              <div className="column is-3">
                <label className="label">Segmentos</label>
                <div className="control">
                  <Select
                    placeholder={"Seleccionar..."}
                    name={"ddlSegmentos"}
                    value={this.state.filtros.segmento}
                    onChange={(value) =>
                      this.handleFilterChange("segmento", value)
                    }
                    noOptionsMessage={() => "No hay opciones"}
                    options={this.state.segmentos}
                    isClearable
                  />
                </div>
              </div>
              <div className="column is-9"></div>
              <div className="column is-3">
                <div className="field">
                  <div className="control has-text-right">
                    <a
                      className="button is-info"
                      onClick={(e) => this.getData(1)}
                    >
                      <span className="icon is-small">
                        <i className="fa fa-search"></i>
                      </span>
                      <span>Buscar</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <div className="card">
          <div className="card-content">
            {this.state.Caffenios.length !== 0 ? (
              <table className="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Segmento</th>
                    <th>Menú</th>
                    <th>Lista Precio</th>
                    <th>Estatus</th>

                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.Caffenios.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.nombre.toUpperCase()}</td>
                        <td>{item.segmento.toUpperCase()}</td>

                        <td>
                          {item.menu == "Pendiente Asignación" ? (
                            <span className="tag is-warning">
                              <strong>{item.menu}</strong>
                            </span>
                          ) : (
                            `${item.menu}`
                          )}
                        </td>
                        <td>
                          {item.listaPrecio == "Pendiente Asignación" ? (
                            <span className="tag is-warning">
                              <strong>{item.listaPrecio}</strong>
                            </span>
                          ) : (
                            `${item.listaPrecio}`
                          )}
                        </td>
                        <td>
                          <Field label="" isHorizontal>
                            <input
                              type="checkbox"
                              name="Active"
                              className="switch"
                              checked={item.activo}
                              onChange={() => {}}
                            />
                            <label
                              htmlFor="isActive"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  caffenio: item,
                                  showConfirm: true,
                                });
                              }}
                            />
                          </Field>
                        </td>
                        <td>
                          {item.activo && (
                            <button
                              className="button is-small tableAction is-danger tooltip"
                              data-tooltip="Macs"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.macs(item);
                              }}
                            >
                              <span className="icon">
                                <i className="fa fa-desktop"></i>
                              </span>
                            </button>
                          )}

                          {item.estatus !== "Registro incompleto" && (
                            <button
                              className="button is-small tableAction is-info tooltip"
                              data-tooltip="App Móvil"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.horarios(item);
                              }}
                            >
                              <span className="icon">
                                <i className="fa fa-cog" />
                              </span>
                            </button>
                          )}

                          <button
                            className="button is-small tableAction is-success tooltip"
                            data-tooltip="Editar"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.edit(item);
                            }}
                          >
                            <span className="icon">
                              <i className="fa fa-edit" />
                            </span>
                          </button>
                          {!item.popAuth && item.activo && (
                            <button
                              className="button is-small tableAction is-warning tooltip"
                              data-tooltip="Sincronizar CaffenioAuth"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState(
                                  { caffenio: item, isLoading: true },
                                  () => this.syncPdv(),
                                );
                              }}
                            >
                              <span className="icon">
                                <i className="fa fa-refresh" />
                              </span>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <NoItems itemName="drives" />
            )}
            <ServerPagination
              totalPages={this.state.Paginator.TotalPages}
              currentPage={this.state.Paginator.Page}
              goToPage={(page) => {
                let paginatorState = this.state.Paginator;
                paginatorState.Page = page;
                this.setState(
                  { Paginator: paginatorState, isLoading: true },
                  () => this.getData(page),
                );
              }}
            />
          </div>
        </div>

        {this.state.showConfirm && (
          <AcceptModal
            modalTitle="Confirmar"
            modalBody={
              <p>
                ¿Está seguro que desea cambiar el estatus{" "}
                {`${this.state.caffenio.nombre}`} ?
              </p>
            }
            isActive={this.state.showConfirm}
            willSave
            done={() => this.changeStatus()}
            cancel={() => this.setState({ caffenio: null, showConfirm: false })}
          />
        )}

        {this.state.showModal && this.state.showConfigVP && (
          <Modal
            showModal={this.state.showModal}
            modalTitle={"Configuración VP"}
            width="85%"
            cancel={this.cancel}
          >
            <ConfiguracionVP
              caffenio={this.state.caffenio}
              save={this.edit}
              cancel={this.cancel}
              tipoDeSolicitudes={this.state.tipoDeSolicitudes.map((obj) => ({
                ...obj,
                Activo: false,
              }))}
            />
          </Modal>
        )}

        <Loading
          isFullscreen={true}
          isLoading={this.state.isLoading}
          width="100px"
          height="100px"
        />
        <BtnModoGuiado />
      </div>
    );
  }
}

export default CaffenioDrive;
